var infiniteOptionsInit = false;
function infiniteOptions() {
    if(!infiniteOptionsInit) {
        $('.selector-wrapper label').each(function() {
            if($(this).html().indexOf('//') !== -1) {
                $(this).parent().hide();

                var selections = [];
                var selectionId = '#' + $(this).attr('for');
                var options = $(this).html().split('//');

                for(var i = 0; i < options.length; i++) selections.push({selectionId: selectionId, title: options[i], options: []});

                var selectOptions = []; 

                for(var i = 0; i < selections.length; i++) {
                    var optionsValues = []
                    $(selections[i].selectionId).children().each(function() {
                        optionsValues.push($(this).html().split('//')[i]);
                    });
                    
                    var optionsValuesUnique = [];
                    $.each(optionsValues, function(i, el){
                        if($.inArray(el, optionsValuesUnique) === -1) optionsValuesUnique.push(el);
                    });

                    selections[i].options = optionsValuesUnique;
                }

                //Generate html
                var html = "";
                var selectionID = "";
                for(var i = 0; i < selections.length; i++) {
                    var optionsHTML = "";
                    for(var f = 0; f < selections[i].options.length; f++) {
                        optionsHTML += '<option value="' + selections[i].options[f] + '">' + selections[i].options[f] + '</option>';
                    }
                    html += '<div class="selector-wrapper c-infinite-options"><label for="' + selections[i].selectionId.replace('#','') + '-' + selections[i].title + '">' + selections[i].title + '</label><select class="single-option-selector ' + selections[i].selectionId.replace('#','') + '" onchange="setInfiniteOptions(\'' + selections[i].selectionId + '\')" id="' + selections[i].selectionId.replace('#','') + '-' + selections[i].title + '">' + optionsHTML + '</select></div>';
                    selectionID = selections[i].selectionId;
                }
                $(selectionID).parent().after(html);
                setOptions(selectionID);
            }
        });
    }
    infiniteOptionsInit = true;
}

function setInfiniteOptions(identifier) {
    var optionId = identifier;
    var optionClass = identifier.replace('#','.');
    var selection = [];
    $('.c-infinite-options select' + optionClass).each(function() {
        selection.push($(this).val());
    });
    $(optionId).val(selection.join('//'));
    $(optionId).trigger('change');
}

function setOptions(identifier) {
    var options = $(identifier).val().split('//');
    var optionClass = identifier.replace('#','.');
    $('.c-infinite-options select' + optionClass).each(function(i) {
        $(this).val(options[i]);
    });
}